import { render, staticRenderFns } from "./pay-channels.vue?vue&type=template&id=deec8114&scoped=true&"
import script from "./pay-channels.vue?vue&type=script&lang=js&"
export * from "./pay-channels.vue?vue&type=script&lang=js&"
import style0 from "./pay-channels.vue?vue&type=style&index=0&id=deec8114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deec8114",
  null
  
)

export default component.exports